var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26249 3.99477C4.12234 4.12731 3.93155 4.20186 3.73252 4.20186C3.5335 4.20186 3.34271 4.12731 3.20255 3.99477L0.216814 1.19427C0.0789136 1.06386 0.00117155 0.887853 0.000347105 0.704183C-0.00079968 0.518088 0.0770907 0.339222 0.216814 0.207095C0.356969 0.0745529 0.547755 -2.83716e-07 0.746783 -2.75556e-07C0.94581 -2.67396e-07 1.1366 0.0745529 1.27675 0.207095L3.73252 2.5105L6.1883 0.221098C6.37764 0.0435055 6.65361 -0.0258522 6.91225 0.0391511C7.17089 0.104154 7.37291 0.293643 7.44222 0.536239C7.51152 0.778835 7.43758 1.03768 7.24824 1.21527L4.26249 3.99477Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryOpen);
export default __webpack_public_path__ + "static/media/category-open.15c8ee03a48aa0385529c2f1bca083e5.svg";
export { ForwardRef as ReactComponent };